<template>
  <fieldset class="traveldates_fieldset">
    <legend>{{ language.datesLegend }}</legend>
    <div class="form-row form-row--wide editable">
      <div class="form-field">
        <input
          type="text"
          name="startdate_dummy"
          ref="startdate"
          readonly
          tabindex="-1"
        />

        <input type="hidden" name="startdate" :value="arrival" readonly />
        <input
          type="hidden"
          name="enddate"
          :value="departure"
          ref="enddate"
          readonly
        />

        <label for="dates">{{ language.dates }}</label>
        <input
          type="text"
          ref="dates"
          name="dates"
          id="dates"
          :class="{ focus: pickerOpen }"
          :value="outputDates"
          @click="openPicker"
          @keydown.enter.prevent="openPicker"
          @focus="onFocus"
        />
        <a
          href="#"
          role="button"
          class="edit-toggle"
          :aria-label="language.editDates"
          @keydown.enter.prevent="openPicker"
          @click.prevent="openPicker"
          >{{ language.editDates }}</a
        >
      </div>
    </div>
  </fieldset>
</template>

<script>
import Litepicker from "litepicker";
import "litepicker-module-navkeyboard";
import moment from "moment/src/moment";

import localizations from "./../../assets/lang/moment.js";

let lang = document.documentElement.getAttribute("lang") || "en";
if (lang == "cn") lang = "zh-" + lang;
if (lang == "zh") lang = lang + "-hk";

// use hk for cn
if (lang == "zh-cn") lang = "zh-hk";

moment.locale(lang);

const localization = localizations[lang] || null;
if (localization) {
  moment.updateLocale(lang, localization);
}

export default {
  name: "Dates",

  data: function () {
    return {
      picker: null,
      pickerOpen: false,
    };
  },

  mounted: function () {
    this.initPicker();
  },

  computed: {
    outputDates: function () {
      return (
        moment(this.arrival).format(this.dateFormat) +
        " - " +
        moment(this.departure).format(this.dateFormat)
      );
    },

    dateFormat: function () {
      return this.$store.state.dateFormatShort;
    },

    language: function () {
      return this.$store.state.language;
    },

    arrival: function () {
      return this.$store.state.arrival;
    },

    departure: function () {
      return this.$store.state.departure;
    },

    availability: function () {
      return this.$store.state.availability;
    },

    availabilityKeys: function () {
      return Object.keys(this.$store.state.availability);
    },
    currentlyLoading: function () {
      return this.$store.state.currentlyLoading;
    },
  },

  methods: {
    isMobile() {
      return window.innerWidth < this.$store.state.mobileBreakpoint;
    },

    onFocus() {
      this.$refs.dates.blur();
      // if (this.pickerOpen && window.innerWidth < this.$store.state.mobileBreakpoint) {
      // 	this.$nextTick(function () {
      // 		this.$refs.dates.focus()
      // 	})
      // }
      this.$emit("focus");
    },

    initPicker: function () {
      const that = this;

      this.$nextTick(function () {
        const pickerOptions = {
          element: this.$refs.startdate,
          elementEnd: this.$refs.enddate,

          // bind picker to input
          parentEl: this.$refs.dates.parentElement,

          numberOfMonths: that.isMobile() ? 1 : 2,
          numberOfColumns: that.isMobile() ? 1 : 2,
          moveByOneMonth: true,

          startDate: moment(this.$store.state.arrival),
          endDate: moment(this.$store.state.departure),
          minDate: moment(),

          scrollToDate: true,
          autoRefresh: true,

          singleMode: false,
          minDays: 1,

          selectForward: false,
          selectBackward: false,

          format: that.$store.state.dateFormat,

          lang: that.getHtmlLang(),

          dropdowns: false,

          hoveringTooltip: true,
          hotelMode: true,

          // disallowLockDaysInRange: true,
          disallowBookedDaysInRange: false,
          // bookedDaysInclusivity: '[)',

          moduleNavKeyboard: true,

          // buttonText: {
          // 	previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"></path></svg>'
          // },

          onRenderDay: function (element) {
            that.mutateDay(element);
          },

          onChangeMonth: function (date) {
            that.$store.dispatch("loadAvailability", {
              startdate: date.dateInstance,
            });
          },

          onShow: function () {
            // loading state
            that.$store.dispatch("loadAvailability", {
              startdate: that.picker.calendars[0].dateInstance,
            });
            //that.handlePickerLoadingState()
          },

          onSelect: function (arrive, depart) {
            that.setDates(arrive, depart);
            that.closePicker();
            that.$emit("closed");
          },

          onRender: function () {
            that.mutateMonths();
          },

          onError: function (error) {
            let cls = null;

            switch (error) {
              case "INVALID_RANGE":
                cls = "date_invalid_range";
                break;
            }

            if (cls) {
              that.$emit("error", cls);
            }
          },
        };

        this.picker = new Litepicker(pickerOptions);
      });
    },

    openPicker: function () {
      const that = this;

      this.$nextTick(function () {
        // todo update picker "content"
        const lockdays = that.availability
          ? Object.keys(that.availability).filter(function (key) {
              const value = that.availability[key];
              return value.price == "-";
            })
          : [];

        that.picker.setOptions({
          bookedDays: lockdays,
        });
        that.picker.show();
        that.picker.picker.focus();
        that.$emit("opened");

        this.pickerOpen = true;
      });
    },

    closePicker: function () {
      this.picker.hide();

      this.pickerOpen = false;
    },
    setDates: function (start, end) {
      this.$store.dispatch("traveldates", { arrival: start, departure: end });
    },

    close: function () {
      return this.closePicker();
    },

    onResize: function () {
      //console.log(wWidth)
    },

    // mutate the days in the picker
    mutateDay: function (element) {
      const formattedDate = moment(
        new Date(parseInt(element.getAttribute("data-time")))
      ).format("YYYY-MM-DD");
      const idx = this.availabilityKeys.indexOf(formattedDate);
      if (element.classList.contains("is-booked")) {
        element.classList.remove("is-booked");
        element.classList.add("book-wmx");
      }
      if (idx != -1) {
        element.setAttribute(
          "data-price",
          this.availability[formattedDate].price
        );
        if (this.availability[formattedDate].price != "-") {
          element.setAttribute(
            "data-currency",
            this.availability[formattedDate].currency_symbol
          );
        }
        if (this.availability[formattedDate].price == "true") {
          element.setAttribute("data-price", "✓");
        }
        if (this.availability[formattedDate].price == "false") {
          element.setAttribute("data-price", "x");
        }
      } else {
        element.setAttribute("data-price", "-");
      }
    },

    // vary rendering of the years in chinese lang
    mutateMonths: function () {
      const lang = this.getHtmlLang();
      this.$nextTick(function () {
        if (lang == "zh-hk") {
          const years = document.querySelectorAll(".month-item-year");
          for (let i = 0; i < years.length; i++) {
            if (years[i].innerHTML != "") {
              years[i].innerHTML = years[i].innerHTML + "年";
            }
          }
        }
      });
    },

    handlePickerLoadingState: function () {
      this.picker.picker.classList.remove("loaded");
      this.picker.picker.classList.add("loading");

      if (!this.currentlyLoading) {
        this.picker.picker.classList.add("loaded");

        this.picker.gotoDate(this.picker.calendars[0].dateInstance);
      }
    },

    getHtmlLang: function () {
      const lang = document.documentElement.getAttribute("lang") || "en";
      if (lang == "cn") return "zh-" + lang;
      if (lang == "zh") return lang + "-hk";

      // use hk for cn
      if (lang == "zh-cn") return "zh-hk";
      return lang;
    },
  },

  watch: {
    currentlyLoading: function () {
      this.handlePickerLoadingState();
    },
  },
};
</script>
